import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEnvelope,
  faPhone,
  faLocationDot,
  faClock,
} from "@fortawesome/free-solid-svg-icons";
import {
  faFacebook,
  faInstagram,
  faLinkedin,
  faTwitter,
} from "@fortawesome/free-brands-svg-icons";
import { Link, useNavigate, useLocation } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleAnchorClick = (e, anchor) => {
    e.preventDefault();

    // Check if we're not on the home page
    if (location.pathname !== "/") {
      // Store the target section in sessionStorage instead of using query params
      sessionStorage.setItem('scrollToSection', anchor.substring(1));
      // Navigate to home page without query parameters
      navigate("/");
    } else {
      // We're already on the home page, just scroll to the anchor
      const element = document.getElementById(anchor.substring(1));
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  };

  return (
    <footer className="footer" >
      <div className="container">
        <div className="footer-content">
          <div className="row">
            <div className="col-lg-4 col-md-6 mb-5">
              <div className="footer-info">
                <h3>Centrul Medical Ali Cranta</h3>
                <p className="mb-3">
                  <FontAwesomeIcon icon={faLocationDot} className="me-2" />
                  Strada Doctor Leonte Anastasievici nr 11 Sector 5, Bucuresti
                </p>
                <p className="mb-2">
                  <FontAwesomeIcon icon={faPhone} className="me-2" />
                  <a href="tel:0725596895">0725 596 895</a>
                </p>
                <p className="mb-2">
                  <FontAwesomeIcon icon={faPhone} className="me-2" />
                  <a href="tel:0724284956">0724 284 956</a>
                </p>
                <p className="mb-4">
                  <FontAwesomeIcon icon={faEnvelope} className="me-2" />
                  <a href="mailto:pneumotherapy@yahoo.com">
                    pneumotherapy@yahoo.com
                  </a>
                </p>
                <p className="mb-2">
                  <FontAwesomeIcon icon={faClock} className="me-2" />
                  <span className="fw-bold">Program:</span>
                </p>
                <p>Luni-Vineri: 08:00 – 21:00</p>

                <div className="social-links mt-4">
                  <a
                    href="https://www.facebook.com/drAliCrantaPneumolog/"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Facebook"
                  >
                    <FontAwesomeIcon icon={faFacebook} />
                  </a>
                  <a
                    href="https://www.instagram.com/your-instagram-profile/"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Instagram"
                  >
                    <FontAwesomeIcon icon={faInstagram} />
                  </a>
                  <a
                    href="https://www.linkedin.com/your-linkedin-profile"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="LinkedIn"
                  >
                    <FontAwesomeIcon icon={faLinkedin} />
                  </a>
                  <a
                    href="https://www.twitter.com/your-twitter-profile"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Twitter"
                  >
                    <FontAwesomeIcon icon={faTwitter} />
                  </a>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 mb-5">
              <div className="footer-links">
                <h4>Link-uri utile</h4>
                <ul>
                  <li>
                    <Link to="/">Acasa</Link>
                  </li>
                  <li>
                    <a href="#about" onClick={(e) => handleAnchorClick(e, "#about")}>Despre noi</a>
                  </li>
                  <li>
                    <a href="#services-wrapper" onClick={(e) => handleAnchorClick(e, "#services-wrapper")}>Servicii</a>
                  </li>
                  <li>
                    <Link to="/cariere">Cariere</Link>
                  </li>
                  <li>
                    <Link to="/prețuri">Prețuri</Link>
                  </li>
                  <li>
                    <Link to="/faq">Întrebări frecvente</Link>
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-lg-4 col-md-12 mb-5">
              <div className="footer-map">
                <h4>Locația Noastră</h4>
                <div className="map-container">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2848.866047857008!2d26.065376851304006!3d44.43590987899974!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40b201801952d2f7%3A0x4959a25917499106!2sAli%20Cranta%20Medical%20Center!5e0!3m2!1sen!2sro!4v1669669163274!5m2!1sen!2sro"
                    width="100%"
                    height="225"
                    title="Location of Ali Cranta Medical Center on Google Maps"
                    style={{ border: 0, borderRadius: "var(--border-radius)" }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="copyright">
            <p>
              &copy; {new Date().getFullYear()} AliCranta Medical Center. Toate
              drepturile rezervate.
            </p>
            <p>
              <a href="https://www.linkedin.com/in/gabriel-mihai-924042234/">
                Soluții complete webdesign, site-web / administrare web.
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
